import MigrateTab from '../MigrateTab';
import React from 'react';

export const COLUMN_HEADERS_DISABLED = [
    { key: 'total', label: 'Total Inventario', value: 'allPropertiesCount' },
    { key: 'email', label: 'Correo electrónico', value: 'email' },
    { key: 'user_phone', label: 'Numero de telefono', value: 'user_phone' },
    { key: 'inactive_last_date', label: 'Fecha de ultima vez activo ', value: 'inactivePropertiesDate' },
     { key: 'actions', label: 'Acciones', value: 'actions' },
];

const MigrateEmailContact = (props) => {

    return (
        <MigrateTab 
            columnHeaders={COLUMN_HEADERS_DISABLED} 
            type="disabled"
            emailContact={props.contactEmail}
            summaryByEmailContact={props.summaryByEmailContact}
            activeTab={props.activeTab}
            mainLoadingSummary={props.loadingSummary}
        />
    );
}

export default MigrateEmailContact;